/* unplugin-vue-components disabled */import script from "./serveComplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./serveComplete.vue?vue&type=script&setup=true&lang=ts"

import "./serveComplete.vue?vue&type=style&index=0&id=0e5d80b4&lang=scss&scope=true"

const __exports__ = script;

export default __exports__